import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../services/authentication/authContext';
import { canAccessSetupOverview } from '../services/accessManagement/accessManagement';
import { useImpersonationStore } from '../stores/appImpersonationStore';
import { primaryText } from '../styling/stylingHelper';

export function SetupOverviewRoute({ children }: { children: JSX.Element }) {
  const { user, backendUser, loading } = useAuth();
  const target = useImpersonationStore(state => state.target);
  const { t } = useTranslation();
  if (loading || (user && (!backendUser || backendUser.id !== (target?.userId ?? user.id)))) {
    return <p role="status" className={`p-6 ${primaryText}`}>{t('common.loading')}</p>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!canAccessSetupOverview(backendUser, target?.userId ?? null)) return <Navigate to="/" replace />;
  return children;
}
